<template>
    <div class="side-bar" :class="{ hidden: !expanded, collapsed: collapsed }">
        <button
            type="button"
            class="side-bar-toggle"
            :title="collapsed ? t('Expand menu') : t('Collapse menu')"
            :aria-label="collapsed ? t('Expand menu') : t('Collapse menu')"
            @click="toggleCollapsed"
        >
            <i class="fas" :class="collapsed ? 'fa-angle-right' : 'fa-angle-left'"></i>
        </button>

        <div class="side-bar-body">
            <div class="side-bar-group">
                <router-link class="side-bar-brand" :title="platformName" :to="{ name: 'home' }">
                    <img v-if="logoUrl" :src="logoUrl" :alt="platformName" class="side-bar-brand-logo" />
                    <div v-else class="side-bar-brand-logo-placeholder" aria-hidden="true"></div>
                </router-link>

                <div class="side-bar-group-title">{{ t("Navigation") }}</div>

                <router-link
                    class="side-bar-option"
                    :class="{ selected: page === 'home' || page === 'project-detail' }"
                    :title="t('Projects')"
                    :to="{ name: 'home' }"
                >
                    <div class="side-bar-option-icon"><i class="fas fa-diagram-project"></i></div>
                    <div class="side-bar-option-text">{{ t("Projects") }}</div>
                </router-link>

                <router-link
                    class="side-bar-option"
                    :class="{ selected: page === 'servers' || page === 'server-detail' }"
                    :title="t('Servers')"
                    :to="{ name: 'servers' }"
                >
                    <div class="side-bar-option-icon"><i class="fas fa-server"></i></div>
                    <div class="side-bar-option-text">{{ t("Servers") }}</div>
                </router-link>
            </div>

            <div v-if="loggedIn" class="side-bar-footer">
                <button type="button" class="side-bar-option" :title="t('Log out')" @click="logout">
                    <div class="side-bar-option-icon"><i class="fas fa-right-from-bracket"></i></div>
                    <div class="side-bar-option-text">{{ t("Log out") }}</div>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { AuthController } from "@/control/auth";
import { useAppEventListener } from "@/composables/useAppEventListener";

defineOptions({ name: "MenuSideBar" });

defineModel<boolean>("expanded");
const collapsed = defineModel<boolean>("collapsed");

const emit = defineEmits<{
    openModal: [name: string];
}>();

const route = useRoute();
const page = ref("");
const loggedIn = ref(AuthController.isAuthenticated());

const platformName = import.meta.env.VITE__PLATFORM_NAME || "Platform";
const logoUrl = import.meta.env.VITE__PLATFORM_LOGO || "";

const toggleCollapsed = () => {
    collapsed.value = !collapsed.value;
};

const logout = () => {
    emit("openModal", "logout");
};

const updatePage = () => {
    page.value = route.name ? (route.name as string) : "";
};

const onAuthChanged = () => {
    loggedIn.value = AuthController.isAuthenticated();
};

onMounted(() => {
    updatePage();
});

watch(() => route.name, updatePage);
useAppEventListener("auth-status-changed", onAuthChanged);
</script>

<style></style>
